import React from "react";

import classNames from "classnames";
import { Button, CloseButton, Modal } from "react-bootstrap";
import { useCoachInfoModalContext } from "../contexts/CoachInfoModal";

const CoachInfoModal = () => {
    const { team, showCoachInfoModal, setShowCoachInfoModal } =
        useCoachInfoModalContext();

    return (
        <Modal
            className={classNames("myScheduleModal")}
            centered
            show={showCoachInfoModal}
            onHide={() => setShowCoachInfoModal(false)}
        >
            <Modal.Header>
                <h4>{team?.name} Contact Info</h4>
                <CloseButton onClick={() => setShowCoachInfoModal(false)} />
            </Modal.Header>
            <Modal.Body>
                <dl className={classNames("inline")}>
                    <dt>Name:</dt>
                    <dd>
                        {team?.coach.firstName} {team?.coach.lastName}
                    </dd>
                    <dt>Email:</dt>
                    <dd>
                        {team?.coach.email && (
                            <a href={`mailto:${team?.coach.email}`}>
                                {team?.coach.email}
                            </a>
                        )}
                    </dd>
                    <dt>Phone:</dt>
                    <dd>{team?.coach.phone}</dd>
                </dl>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="primary"
                    onClick={() => setShowCoachInfoModal(false)}
                >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CoachInfoModal;
